"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthLayout = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const use_promise_1 = require("../hook/use-promise");
const user_1 = require("../network/user");
const use_lazy_promise_1 = require("../hook/use-lazy-promise");
const loading_layout_1 = require("./loading-layout");
const react_router_dom_1 = require("react-router-dom");
const user_context_1 = require("../context/user-context");
const header_1 = require("./header/header");
const material_1 = require("@mui/material");
exports.AuthLayout = (0, react_1.memo)(({ loadingLayout }) => {
    const { result: userMeta, status, refresh } = (0, use_promise_1.usePromise)(user_1.getUserMeta);
    const navigate = (0, react_router_dom_1.useNavigate)();
    (0, react_1.useEffect)(() => {
        if (status === use_lazy_promise_1.FetchStatus.Error) {
            navigate("/");
        }
    }, [status, userMeta, navigate]);
    return userMeta ? ((0, jsx_runtime_1.jsx)(user_context_1.UserUpdateContext.Provider, { value: { refresh }, children: (0, jsx_runtime_1.jsx)(user_context_1.UserContext.Provider, { value: {
                userMeta,
            }, children: (0, jsx_runtime_1.jsxs)(material_1.Stack, { direction: "column", alignItems: "center", height: "100%", flexGrow: 1, children: [(0, jsx_runtime_1.jsx)(header_1.Header, {}), (0, jsx_runtime_1.jsx)(material_1.Stack, { width: "100%", direction: "column", flex: 1, overflow: "auto", children: (0, jsx_runtime_1.jsx)(react_router_dom_1.Outlet, {}) })] }) }) })) : status === use_lazy_promise_1.FetchStatus.Loading ? (loadingLayout || (0, jsx_runtime_1.jsx)(loading_layout_1.LoadingLayout, {})) : null;
});
exports.AuthLayout.displayName = "AuthLayout";
